import { ButtonType, ButtonWidget, DialogType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ModalInstance, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';

import { MaxConfigurationsReachedDialogueStyle, MaxConfigurationsReachedTitleStyle } from '../../styles/SiteAuthenticationSettingsStyles';

export function MaxConfigurationsReachedDialog() {
    let modalInstance: ModalInstance<unknown>;
    const dialogProps = {
        close: () => modalInstance && modalInstance.close({}),
        dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    };

    modalInstance = ReactModalService.open({
        type: DialogType.Uber,
        dialogContent: React.createElement(MaxConfigurationReachedContent, dialogProps),
        testId: 'maxConfigurationsDialog',
        showCloseButton: true,
        dialogStyle: MaxConfigurationsReachedDialogueStyle,
        shouldNotSetDefaultWidth: true
      });

    return Promise.resolve(modalInstance.result);
}

export interface MaxConfigurationReachedContentState {

}

export interface MaxConfigurationReachedContentProps {
    readonly close: () => void;
    readonly dismiss: () => void;
}


export class MaxConfigurationReachedContent extends React.Component<MaxConfigurationReachedContentProps, MaxConfigurationReachedContentState> {

    public render() {
        return (
            <div style={{width: 375}}>
                <div style={MaxConfigurationsReachedTitleStyle}>{Messages.siteAuthenticationMaxConfigLimitTitle()}</div>
                <div>{Messages.siteAuthenticationMaxConfigLimitMessage()}</div>
                <div className="tb-dialog-actions">
                    <span className="tb-margin-left-wide">
                        <ButtonWidget
                            buttonType={ButtonType.Outline}
                            onClick={this.props.dismiss}
                            testId={'confirm-action-dialog-cancel'}
                            children={Messages.close()}
                        />
                    </span>
                </div>
            </div>
        );
    }
}